import { memo } from "react";
import { useTranslate } from "helpers";
import { initialDataWithPagination } from "services/api/consts";
import { TableSearch } from "ui/components/Table/TableSearch";
import VehicleDocumentRowChild from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleDocumentCard/components/VehicleDocumentSearchResults/components/VehicleDocumentRowChild";
import { FLEET_VEHICLE_DOCUMENT_UPLOADS_SEARCH_COLUMNS } from "ui/modules/fleet/vehicles/pages/VehicleDetailPage/components/VehicleDetailCard/components/VehicleDocumentCard/components/VehicleDocumentSearchResults/consts";
import { FINANCE_DOCUMENT_SEARCH_COLUMNS } from "./consts";
import { DocumentSearchResultsProps } from "./types";

const DocumentSearchResults: React.FC<DocumentSearchResultsProps> = (props) => {
  const {
    searchResults,
    selectedRows,
    isLoading,
    onRowClick,
    onPaginationChange,
    onSelectedChange,
    onDeleteClick,
    onVehicleClick,
  } = props;

  const { t } = useTranslate();

  return (
    <TableSearch
      columns={FINANCE_DOCUMENT_SEARCH_COLUMNS(t, onDeleteClick, onVehicleClick)}
      data={searchResults.data}
      selectedRows={selectedRows}
      pagination={searchResults.pagination || initialDataWithPagination.pagination}
      selectableRows={false}
      onPaginationChange={onPaginationChange}
      onSelectedChange={onSelectedChange}
      isLoading={isLoading}
      onRowClick={onRowClick}
      columnsChild={FLEET_VEHICLE_DOCUMENT_UPLOADS_SEARCH_COLUMNS(t)}
      CustomTableRowChild={(childProps) => (
        <VehicleDocumentRowChild
          {...childProps}
          onFetchSearchResult={() =>
            onPaginationChange?.(searchResults.pagination)
          }
        />
      )}
    />
  );
};

export default memo(DocumentSearchResults);
